module.exports = __webpack_public_path__ + "static/media/carousal_2_mobile.dbe1cf93.jpg";